__turbopack_context__.v({
  "controls": "TestimonialSlider-module-scss-module__bOp-Fa__controls",
  "fade-in": "TestimonialSlider-module-scss-module__bOp-Fa__fade-in",
  "header": "TestimonialSlider-module-scss-module__bOp-Fa__header",
  "heading": "TestimonialSlider-module-scss-module__bOp-Fa__heading",
  "indicator": "TestimonialSlider-module-scss-module__bOp-Fa__indicator",
  "indicatorDot": "TestimonialSlider-module-scss-module__bOp-Fa__indicatorDot",
  "indicatorDotActive": "TestimonialSlider-module-scss-module__bOp-Fa__indicatorDotActive",
  "no-transform": "TestimonialSlider-module-scss-module__bOp-Fa__no-transform",
  "quote": "TestimonialSlider-module-scss-module__bOp-Fa__quote",
  "rotate": "TestimonialSlider-module-scss-module__bOp-Fa__rotate",
  "slide": "TestimonialSlider-module-scss-module__bOp-Fa__slide",
  "slider": "TestimonialSlider-module-scss-module__bOp-Fa__slider",
  "slidesContainer": "TestimonialSlider-module-scss-module__bOp-Fa__slidesContainer",
  "testimonials": "TestimonialSlider-module-scss-module__bOp-Fa__testimonials",
});
